import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative inline-block" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none" }


import ChevronIcon from "@/components/icons/ChevronIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSelect',
  props: {
    items: {},
    defaultValue: {}
  },
  emits: ["selectOption"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      value: __props.defaultValue ?? '',
      class: "border rounded-[100px] text-sm text-brown px-4 py-[12px] appearance-none w-full select-none",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('selectOption', $event.target.value)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          value: item,
          class: "text-sm text-brown"
        }, [
          _renderSlot(_ctx.$slots, "option", { item: item }, () => [
            _createTextVNode(_toDisplayString(item), 1)
          ])
        ], 8, _hoisted_3))
      }), 128))
    ], 40, _hoisted_2),
    _createElementVNode("span", _hoisted_4, [
      _createVNode(ChevronIcon)
    ])
  ]))
}
}

})